import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import BuyButton from '../BuyButton';
import constants from '../../constants';
import BuyButtonWithNotice from "./BuyButtonWithNotice";

const ProductQuantity = ({
  articleNumber,
  quantityFieldId,
  minQuantity,
  stockQuantity,
  isOrderItem,
  comment
}) => {
  const [quantity, setQuantity] = useState(minQuantity);
  const [errorMessage, setErrorMessage] = useState('');
  const isViewOnlyUser = constants.isViewOnlyUser;

  useEffect(() => {
    setErrorMessage('');
  }, [quantity]);

  function decrement() {
    if (quantity - minQuantity > 0) {
      setQuantity(quantity - minQuantity);

      return;
    }

    setErrorMessage(translate('cart.item.quantity.minquantity'));
  }

  function increment() {
    let newTotal = quantity + minQuantity;
    if (isOrderItem) {
      setQuantity(newTotal);
      return;
    }
    if (isAvailableInStock(newTotal)) {
      setQuantity(newTotal);

      return;
    }

    setErrorMessage(translate('cart.item.quantity.notenoughinstock'));
  }

  function isAvailableInStock(newTotal) {
    return newTotal <= stockQuantity;
  }

  return (
    <>
      <div style={{ display: 'flex', gridGap: 10 }}>
        <div className="quantity__container">
          <button className="quantity__button" onClick={() => decrement()}>
            -
          </button>
          <input
            className="quantity__input"
            onChange={(e) => {
              let number = +e.target.value;
              if (number >= 1) {
                setQuantity(number);
              }
            }}
            type="number"
            value={+quantity}
            readOnly={true}
            id={quantityFieldId}
            data-buy-quantity-input
          />
          <button className="quantity__button" onClick={() => increment()}>
            +
          </button>
        </div>

        <div className="product__buy-button-container">
            {
                comment ? <BuyButtonWithNotice
                        items={[
                            {
                                articleNumber: articleNumber,
                                quantity: quantity,
                            },
                        ]}
                        comment={comment}
                        quantityFieldId={quantityFieldId}
                        cssClass="product__buy-button product__buy-button--fullwidth"
                        label={translate('product.buy')}
                        articleNumber={articleNumber}
                        quantity={quantity}
                    ></BuyButtonWithNotice> :
                    <BuyButton
                        quantityFieldId={quantityFieldId}
                        cssClass="product__buy-button"
                        label={translate('product.buy')}
                        articleNumber={articleNumber}
                        quantity={quantity}
                    ></BuyButton>
            }
        </div>
      </div>
      {errorMessage && (
        <p className="quantity__error-message">{errorMessage}</p>
      )}
    </>
  );
};

export default ProductQuantity;
